<template>
	<div class="bookmarks-actions-container" v-if="this.$route.name === 'bookmarks' ">
		<div class="filter-group">
			<select class="category-select" v-model="filteredBy">
				<option value="">{{ $t('sorting.displayAll') }}</option>
				<option value="companies">{{ $t('companyList.destinations') }}</option>
				<option value="salespoints">{{ $t('companyList.salespoints') }}</option>
			</select>
		</div>

    <map-button/>
	</div>
</template>
<script>

  import MapButton from '@/components/MapButton.vue'

	export default {
		name: 'BookmarksActions',
		data () {
			return {
				filteredBy: ''
			}
		},
    components: {
      MapButton
    },
		watch: {
			filteredBy: function (value) {
				this.$eBus.$emit('update-bookmarks-entity-filter', value)
			}
		}
	}
</script>

<style lang="scss" scoped>

  .map-button-wrapper {
    margin-top: 2rem;
  }

	.bookmarks-actions-container{
		margin: 0 auto;
		margin-top: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

		.filter-group{

      .category-select  {
        max-width: 300px;
        background-color: $light-gray;
        border-radius: 50px;
        font-weight: bold;
        border: 1px solid $medium-gray;
        color: $dark-gray;
        margin: 0;
        font-size: 0.9rem;
        height: rem-calc(48px);
      }
		}

		.filter-wrapper{
			// @include xy-cell(1, false, 0);
			display: flex;
			display: none;
			align-items: center;
			justify-content: flex-end;

			.btn-filter{
				margin: 0;
				color: $dark-gray;
				border: 1px solid $dark-gray;
				border-radius: 20rem;

				&:hover,
				&:focus {
					color: scale-color($dark-gray, $lightness: -15%);
					border: 1px solid scale-color($dark-gray, $lightness: -15%);
				}
			}
		}
	}
</style>
